import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslate } from 'hooks/useTranslate';

import GoBackButton from 'modules/_shared/components/Buttons/GoBackButton';
import { useAddTradingOfferPage } from '../context/AddTradingOfferPageContext';
import AddTradingOfferResumeSection from './AddTradingOfferResumeSection';
import AddTradingOfferDataSection from './AddTradingOfferDataSection';

const AddTradingOfferPageBody: FC = () => {
  const { t } = useTranslate();
  const history = useHistory();
  const { data } = useAddTradingOfferPage();

  if (data.isMarketClosed) {
    return (
      <div className="nk-block">
        <div className="alert alert-warning alert-icon mb-4" role="alert">
          <em className="icon ni ni-alert-circle" />
          <div>{t('MarketClosedOrUnavailable')}</div>
        </div>
        <GoBackButton
          icon="ni-arrow-left"
          customAction
          onClick={() => history.push(`/mercado-de-acciones/${data.societyId}`)}
        />
      </div>
    );
  }

  return (
    <div className="nk-block">
      <div className="row">
        <AddTradingOfferDataSection />

        <AddTradingOfferResumeSection />
      </div>
    </div>
  );
};

export default AddTradingOfferPageBody;
